import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Handshake } from 'lucide-react';
interface FriendSite {
  name: string;
  nameCn: string;
  url: string;
  description: string;
}
const friendSites: FriendSite[] = [{
  name: 'TTVIP',
  nameCn: 'TTVIP',
  url: '#',
  description: 'TTVIP是新加坡知名的高端伴游信息平台，与芽笼777长期保持战略合作关系。TTVIP以严格的伴游筛选标准和优质的客户服务著称，为新加坡高端客户群体提供专属的VIP伴游体验。两大平台强强联合，共同引领新加坡伴游服务行业的品质标准。'
}, {
  name: 'SGHarem',
  nameCn: '新加坡后宫网',
  url: '#',
  description: '新加坡后宫网（SGHarem）是新加坡历史最悠久的伴游信息社区之一，拥有庞大的用户基础和丰富的伴游资源。SGHarem以其活跃的社区讨论和真实的用户评价闻名，是新加坡伴游爱好者获取一手资讯的重要渠道。芽笼777与SGHarem携手合作，为用户提供更全面的信息覆盖。'
}, {
  name: 'SGLonelyGuy',
  nameCn: '新加坡寂寞男人',
  url: 'https://sglonelyguy.me',
  description: '新加坡寂寞男人（SGLonelyGuy）是新加坡最活跃的男性社交与伴游信息论坛，汇聚了大量真实用户的体验分享和推荐。SGLonelyGuy社区以其真实、直接的交流氛围深受用户喜爱，是了解新加坡伴游市场动态的重要窗口。芽笼777在SGLonelyGuy社区中享有极高的口碑和推荐率。'
}, {
  name: 'SGBeautyCastle',
  nameCn: '新加坡美丽城堡',
  url: 'https://sgbeautycastle.live',
  description: '新加坡美丽城堡（SGBeautyCastle）专注于展示新加坡最优质的伴游档案，以精美的图片展示和详细的个人介绍著称。SGBeautyCastle注重视觉体验和信息质量，为客户提供直观、便捷的伴游浏览体验。芽笼777与SGBeautyCastle共享优质伴游资源，确保客户获得最丰富的选择。'
}, {
  name: 'xfy1.net',
  nameCn: '幸福缘',
  url: 'https://xfy1.net',
  description: '幸福缘（xfy1.net）是面向华人用户的综合性伴游与社交平台，以"缘分天注定"为理念，为客户搭建高品质的社交桥梁。幸福缘平台覆盖新加坡、马来西亚等东南亚地区，拥有广泛的用户网络。芽笼777与幸福缘在新加坡市场深度合作，为华人客户提供无缝衔接的服务体验。'
}, {
  name: 'Shiok8',
  nameCn: '新加坡爽吧',
  url: 'https://shiok8.xyz',
  description: '新加坡爽吧（Shiok8）是新加坡本地最受欢迎的娱乐资讯平台之一，"Shiok"在新加坡俚语中意为"爽、过瘾"。Shiok8涵盖夜生活、美食、娱乐等多个领域的资讯，为用户提供全方位的新加坡生活指南。芽笼777与Shiok8在伴游服务领域展开深度合作，共同为客户打造极致的"Shiok"体验。'
}, {
  name: 'isyou.net',
  nameCn: '新加坡是您网',
  url: 'https://isyou.net',
  description: '新加坡是您网（isyou.net）是一个以用户为中心的伴游信息平台，"Is You"寓意"就是你"，强调为每位客户找到最匹配的伴游伙伴。isyou.net以其智能推荐系统和个性化服务方案著称，帮助客户快速找到心仪的伴游对象。芽笼777与isyou.net在技术和资源层面紧密合作，共同提升用户体验。'
}, {
  name: 'geylang777.info',
  nameCn: '芽笼777资讯站',
  url: 'https://geylang777.info',
  description: '芽笼777资讯站（geylang777.info）是芽笼777的官方资讯分站，提供最新的伴游行业动态、服务指南和平台公告。作为芽笼777生态的重要组成部分，geylang777.info为用户提供权威、及时的一手资讯，确保客户随时掌握新加坡伴游市场的最新动向。'
}, {
  name: 'geylang666.me',
  nameCn: '芽笼666',
  url: 'https://geylang666.me',
  description: '芽笼666（geylang666.me）是新加坡芽笼地区知名的伴游信息平台，以"666"寓意顺利、精彩的服务体验。geylang666.me汇聚优质伴游资源，为客户提供便捷的浏览和预约服务。芽笼777与芽笼666强强联手，共同打造新加坡芽笼地区最完善的伴游服务网络。'
}, {
  name: 'ttvip-62.site',
  nameCn: 'TTVIP-62',
  url: 'https://ttvip-62.site',
  description: 'TTVIP-62（ttvip-62.site）是TTVIP旗下的精品伴游服务分站，专注于为VIP客户提供更加精准、个性化的高端伴游匹配服务。ttvip-62.site以严格的品质把控和贴心的客户关怀著称，是新加坡高端伴游服务的标杆之一。芽笼777与TTVIP-62携手合作，共同服务高端客户群体。'
}, {
  name: 'shiok26.site',
  nameCn: '爽26',
  url: 'https://shiok26.site',
  description: '爽26（shiok26.site）是新加坡本地热门的娱乐与伴游资讯平台，"Shiok"在新加坡俚语中代表极致享受。shiok26.site以丰富的伴游档案和真实的用户反馈为特色，帮助客户快速找到满意的伴游服务。芽笼777与爽26在资源共享和用户服务方面保持紧密合作。'
}, {
  name: 'sgharem.site',
  nameCn: '新加坡后宫',
  url: 'https://sgharem.site',
  description: '新加坡后宫（sgharem.site）是SGHarem的官方新站点，延续了SGHarem社区的优良传统，为用户提供最新的伴游信息和社区互动体验。sgharem.site以活跃的用户社区和丰富的伴游资源闻名，是新加坡伴游爱好者的必访平台。芽笼777与新加坡后宫保持长期战略合作。'
}, {
  name: 'xfy8.com',
  nameCn: '幸福缘8',
  url: 'https://xfy8.com',
  description: '幸福缘8（xfy8.com）是幸福缘系列平台的旗舰站点，以"8"寓意发财、好运，为华人客户提供优质的伴游社交服务。xfy8.com覆盖新加坡及东南亚地区，拥有庞大的伴游资源库和成熟的服务体系。芽笼777与幸福缘8深度合作，为华人用户打造无缝衔接的高品质伴游体验。'
}, {
  name: 'TTVIP.life',
  nameCn: 'TTVIP生活',
  url: 'https://ttvip.life',
  description: 'TTVIP生活（ttvip.life）是TTVIP品牌旗下的全新生活方式平台，致力于为VIP会员提供全方位的高端生活服务体验。ttvip.life不仅涵盖伴游服务，更延伸至美食、旅游、娱乐等多个生活领域，打造一站式的精英生活服务生态。芽笼777与TTVIP.life携手，为客户提供更加丰富多元的高端服务选择。'
}, {
  name: 'Locanto.space',
  nameCn: 'Locanto空间',
  url: 'https://locanto.space',
  description: 'Locanto空间（locanto.space）是新加坡本地知名的分类信息与社交平台，为用户提供便捷的信息发布和浏览服务。Locanto.space在伴游服务领域拥有丰富的资源和活跃的用户社区，是新加坡伴游市场的重要信息枢纽。芽笼777与Locanto.space在信息共享和用户服务方面保持紧密合作。'
}, {
  name: 'KKBaby',
  nameCn: 'KK宝贝',
  url: 'https://kkbaby.site',
  description: 'KK宝贝（kkbaby.site）是新加坡新兴的优质伴游信息平台，以年轻、时尚、活力为品牌特色。KKBaby专注于为客户提供年轻化、个性化的伴游服务体验，平台汇聚了大量年轻优质的伴游资源。芽笼777与KKBaby在年轻客户群体服务方面展开深度合作，共同打造新一代伴游服务标准。'
}];
export function FriendLinks() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-[#0d0d14]" data-id="element-81">
      <div className="max-w-6xl mx-auto" data-id="element-82">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={containerVariants} data-id="element-83">
          <motion.div variants={itemVariants} className="flex items-center justify-center gap-3 mb-4" data-id="element-84">
            <Handshake size={28} className="text-pink-primary" data-id="element-85" />
            <h2 className="text-3xl md:text-5xl font-bold" data-id="element-86">
              友情<span className="text-pink-primary neon-glow" data-id="element-87">链接</span>
            </h2>
          </motion.div>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full mb-4" data-id="element-88" />
          <motion.p variants={itemVariants} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-89">
            Partner Sites — 新加坡伴游服务生态联盟
          </motion.p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-90">
          {friendSites.map((site, index) => <motion.a key={index} href={site.url} target="_blank" rel="noopener noreferrer" variants={itemVariants} className="bg-dark-card rounded-2xl p-6 md:p-8 border border-white/5 hover:border-pink-primary/40 transition-all duration-300 group block" data-id="element-91">
              <div className="flex items-center justify-between mb-4" data-id="element-92">
                <div data-id="element-93">
                  <h3 className="text-lg font-bold text-white group-hover:text-pink-primary transition-colors" data-id="element-94">
                    {site.name}
                  </h3>
                  <p className="text-sm text-pink-primary/70" data-id="element-95">{site.nameCn}</p>
                </div>
                <ExternalLink size={18} className="text-gray-600 group-hover:text-pink-primary transition-colors" data-id="element-96" />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-97">
                {site.description}
              </p>
            </motion.a>)}
        </motion.div>

        {/* SEO-rich summary paragraph */}
        <motion.div className="mt-16 bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-99">
            芽笼777 — 新加坡伴游服务行业的核心枢纽
          </h3>
          <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-100">
            <p data-id="element-101">
              芽笼777（geylang777.net）作为新加坡伴游信息服务领域的领军平台，与TTVIP、新加坡后宫网（SGHarem）、新加坡寂寞男人（SGLonelyGuy）、新加坡美丽城堡（SGBeautyCastle）、幸福缘（xfy1.net）、新加坡爽吧（Shiok8）以及新加坡是您网（isyou.net）等行业知名平台建立了紧密的合作伙伴关系。
            </p>
            <p data-id="element-102">
              这一强大的平台联盟覆盖了新加坡伴游服务市场的各个细分领域：从高端VIP定制服务到大众化的伴游信息查询，从专业的伴游档案展示到活跃的用户社区交流，从华人专属服务到国际化多语言支持。芽笼777与各友站的深度合作，为客户构建了一个完整、可靠、高效的新加坡伴游服务生态系统。
            </p>
            <p data-id="element-103">
              无论您是通过芽笼777的Telegram频道（t.me/gl777net）获取最新资讯，还是通过我们的官方网站（geylang777-6.site）浏览伴游档案，亦或是通过我们的合作伙伴平台了解更多选择，芽笼777始终致力于为您提供最安全、最优质、最满意的伴游服务体验。选择芽笼777，选择新加坡伴游服务的品质保证。
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}